import React from "react";
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import Config from "../../../config";
import {Button, Card, CardContent, Typography} from "@material-ui/core";
import Formsy from "formsy-react";
import classNames from 'classnames';
import {TextFieldFormsy, FuseAnimate} from '@fuse';
import axiosInstance from "../common/AxiosInstace";
import EndpointsGetter from "../common/EndpointsGetter";
import {Modal} from 'react-bootstrap';

const styles = theme => ({
    root: {
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover'
    },
    intro: {
        color: '#ffffff'
    },
    card: {
        width: '100%',
        maxWidth: 400
    }
});

class ResetPassword extends React.Component{

    state = {
        error: null,
        canSubmit: false,
        show: false,
        modalMessage: ''
    };

    resetPassword(data) {
        if (typeof this.props.location.search === "undefined" || this.props.location.search === "") {
            let oldState = {...this.state};
            oldState.modalMessage = "There is no provided parameter in URL.";
            oldState.show = true;
            this.setState(oldState);
            return
        }
        let uid = this.getUid(this.props.location.search);

        if (data.password !== data.rePassword) {
            let oldState = {...this.state};
            oldState.modalMessage = "Passwords do not match! They must be identical.";
            oldState.show = true;
            this.setState(oldState);
            return
        }

        // check if token is expired
        axiosInstance.get(EndpointsGetter.getVerifyResetPasswordEndpoint() + "?uid=" + uid)
            .then(response => {

                // not expired
                let body = [];
                body["password"] = data.password;
                body["rePassword"] = data.rePassword;

                let qs = require('qs');
                axiosInstance.put(EndpointsGetter.getResetPasswordEndpoint() + "?uid=" + uid, qs.parse(body), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        this.props.history.push({
                            pathname: '/login',
                            message: 'Your password has been successfully updated.'
                        });
                    })
                    .catch(error => {
                        let oldState = {...this.state};
                        if (error.response.data.status == 400) {
                            oldState.modalMessage = error.response.data.message;
                        } else {
                            oldState.modalMessage = 'Resetting password failed! Please contact Kanin Support.';
                        }
                        oldState.show = true;
                        this.setState(oldState);
                    });
            })
            .catch(error => {
                let oldState = {...this.state};
                if (error.response.data.status == 400) {
                    oldState.modalMessage = error.response.data.message;
                } else {
                    oldState.modalMessage = 'Verifying reset password token failed! Please contact Kanin Support.';
                }
                oldState.show = true;
                this.setState(oldState);
            });
    }

    getUid(search) {
        // search = '?uid=b3d635c2-26ff-4bf0-9e70-18f591b9ff08'
        let path = search.split("=");
        if (path.length < 2) {
            let oldState = {...this.state};
            oldState.modalMessage = "Incorrect parameters in URL.";
            oldState.show = true;
            this.setState(oldState);
        }
        let parameter = path[0];
        if (parameter != "?uid") {
            let oldState = {...this.state};
            oldState.modalMessage = "Incorrect parameters in URL.";
            oldState.show = true;
            this.setState(oldState);
        }
        return path[1]
    }

    disableButton = () => {
        this.setState({canSubmit: false});
    };

    enableButton = () => {
        this.setState({canSubmit: true});
    };

    handleHideModal() {
        this.state.show = false;
        this.forceUpdate();
    }


    render() {
        const {classes} = this.props;

        return (
            <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 sm:flex-col md:flex-col md:p-0")}>

                <div className={classNames(classes.root, "flex flex-col flex-1 flex-no-shrink p-24 md:flex-row md:p-0")}>

                    <div className={classNames(classes.intro, "flex flex-col flex-no-grow items-center p-16 text-center md:p-128 md:items-start md:flex-no-shrink md:flex-1 md:text-left")}>
                        <FuseAnimate animation="transition.expandIn">
                            <img className="w-512 mb-32" src="assets/images/logos/kanin_h.png" alt="logo"/>
                        </FuseAnimate>

                        <div className={"hidden-sm hidden-xs"} style={{color:'white', 'bottom': '1%', 'left': '1%', 'position': 'absolute', 'font-size': '1.5vh'}}>
                            <div style={{'textAlign':'left'}}>v.{Config.versionNumber} #{Config.buildVersion}</div>
                            {Config.company}
                        </div>
                    </div>

                    <FuseAnimate animation={{translateX: [0, '100%']}}>

                        <Card className={classNames(classes.card, "mx-auto m-16 md:m-0")}>

                            <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">

                                <Typography variant="title" className="md:w-full mb-32">RESET PASSWORD</Typography>

                                <Formsy
                                    onValidSubmit={(model) => this.resetPassword(model)}
                                    onValid={this.enableButton}
                                    onInvalid={this.disableButton}
                                    ref={(form) => this.form = form}
                                    className="flex flex-col justify-center w-full"
                                >
                                    <div style={{color: 'red', marginBottom: 5}}>
                                        {this.state.error != null ? this.state.error : null}
                                    </div>
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="password"
                                        name="password"
                                        label="New Password"
                                        validations={{
                                            minLength: 1
                                        }}
                                        validationErrors={{
                                            minLength: 'Password cannot be empty'
                                        }}
                                        required
                                    />
                                    <TextFieldFormsy
                                        className="mb-16"
                                        type="password"
                                        name="rePassword"
                                        label="Repeat Password"
                                        validations={{
                                            minLength: 1
                                        }}
                                        validationErrors={{
                                            minLength: 'Password cannot be empty'
                                        }}
                                        required
                                    />

                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        className="w-full mx-auto mt-16 normal-case"
                                        aria-label="RESET"
                                        disabled={!this.state.canSubmit}
                                        value="legacy"
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        href="/login"
                                        variant="raised"
                                        className="w-full mx-auto mt-16 normal-case"
                                        aria-label="BACK"
                                        value="legacy"
                                    >
                                        Back to Login
                                    </Button>

                                </Formsy>
                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
                <div className={"hidden-md hidden-lg hidden-xl"} style={{color:'white', 'bottom': '1%', 'left': '1%', 'font-size': '1.5vh'}}>
                    v.{Config.versionNumber} #{Config.buildVersion}<br/>
                    {Config.company}
                </div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleHide}
                    container={this}
                    aria-labelledby="contained-modal-title"
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title">
                            Message
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalMessage}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-info"
                                onClick={(e) => this.handleHideModal()}>
                            OK
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>

        );
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(ResetPassword));


// WEBPACK FOOTER //
// ./src/main/content/reset-password/ResetPassword.js